module.exports = __webpack_public_path__ + "static/getting-to-yes-1764e2337d662d787df545a030e8bf15.jpg";